export default "__VITE_ASSET__DYZXf7JO__"